const log = {
    ru: {

    },
    fr: {

    }
}

export default log